import clsx from "clsx";

import type { Props } from "./types";

const LoadingSpinner = (props: Readonly<Props>) => {
  const {
    className = "",
    color = "#000",
    thickness = 2,
    height,
    width
  } = props;

  return (
    <div
      className={clsx(`rounded-full animate-spin`, className)}
      style={{
        borderWidth: thickness,
        borderColor: color,
        borderTopColor: "transparent",
        width,
        height
      }}
    />
  );
};

export default LoadingSpinner;
